import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '', keywords, jsonLd = null, image }) => {
  const url = `https://amigosbailbonds.com${path}`;
  const ogImage = image || 'https://amigosbailbonds.com/brand/amigos-logo.png';
  const jsonBlocks = jsonLd == null ? [] : Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
      <meta name="geo.region" content="US-TX" />
      <meta name="geo.placename" content="Conroe, Montgomery County, Texas" />
      <meta name="geo.position" content="30.3118;-95.4560" />
      <meta name="ICBM" content="30.3118, -95.4560" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Amigo's Bail Bonds" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="es_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonBlocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
